// ==================== PERFORMANCE UTILITIES ====================

// Geräte-Erkennung für adaptive Animationen
export const DevicePerformance = {
  isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768,
  isLowPower: navigator.hardwareConcurrency ? navigator.hardwareConcurrency <= 4 : false,
  prefersReducedMotion: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false,
  isLowMemory: navigator.deviceMemory ? navigator.deviceMemory < 4 : false,
  
  getIntensity(baseIntensity) {
    if (this.prefersReducedMotion) return 0;
    if (this.isLowMemory || this.isLowPower) return Math.floor(baseIntensity * 0.3);
    if (this.isMobile) return Math.floor(baseIntensity * 0.5);
    return baseIntensity;
  }
};

// Debounce-Helper für Event-Handler
export const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

// Throttle-Helper für häufige Events
export const throttle = (fn, limit) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      fn(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// RAF-Throttle für Scroll/Resize
export const rafThrottle = (fn) => {
  let rafId = null;
  return (...args) => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      fn(...args);
      rafId = null;
    });
  };
};
